import Cookies from "js-cookie";
import axios from "./axios";
import toast from "react-hot-toast";

export const GET = async (url, options = {}) => {
  try {
    const response = await axios.get(url, options);
    return response.data;
  } catch (err) {
    if (!err.response) {
      throw err;
    }
    return Promise.reject(err.response);
  }
};

export const DELETE = async (url, options = {}) => {
  try {
    const response = await axios.delete(url, options);
    return response.data;
  } catch (err) {
    if (!err.response) {
      throw err;
    }
    return Promise.reject(err.response);
  }
};

export const POST = async (url, data = undefined, options = {}) => {
  try {
    const response = await axios.post(url, data, options);
    return response.data;
  } catch (err) {
    if (!err.response) {
      throw err;
    }
    return Promise.reject(err.response);
  }
};

export const PUT = async (url, data = undefined, options = {}) => {
  try {
    const response = await axios.put(url, data, options);
    return response.data;
  } catch (err) {
    if (!err.response) {
      throw err;
    }
    return Promise.reject(err.response);
  }
};

export const PATCH = async (url, data = undefined, options = null) => {
  try {
    const response = await axios.patch(url, data, options);
    return response.data;
  } catch (err) {
    if (!err.response) {
      throw err;
    }
    return Promise.reject(err.response);
  }
};

export const POSTSSE = async (url, data = {}, options = {}) => {
  const {
    headers = {},
    onStream,
    withCredentials = true,
    skipErrorToast = false,
    isExtension = false,
    ...restOptions
  } = options;

  const cookieName = process.env.REACT_APP_PR_ACCESS_TOKEN || "accessToken";
  const token = Cookies.get(cookieName);

  const finalHeaders = {
    "Content-Type": "application/json",
    Accept: "application/json",
    ...headers,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: finalHeaders,
      body: JSON.stringify(data),
      credentials: withCredentials ? "include" : "omit",
      ...restOptions,
    });

    if (!response.ok) {
      if (!skipErrorToast) handleFetchErrors(response, isExtension);
      throw new Error(`SSE request failed: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let buffer = "";

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n");
      buffer = lines.pop(); // save partial line

      for (const line of lines) {
        if (line.startsWith("data:")) {
          try {
            const jsonStr = line.replace("data:", "").trim();
            const json = JSON.parse(jsonStr);
            onStream?.(json); // 🔥 pass streamed chunk
          } catch (e) {
            console.error("❌ Failed to parse SSE line:", line);
          }
        }
      }
    }

    return null;
  } catch (error) {
    console.error("❌ POSTSSE Error:", error);
    throw error;
  }
};

const handleFetchErrors = async (response, isExtension) => {
  const status = response.status;
  let msg = "";

  try {
    const json = await response.json();
    msg = json.message || "";
  } catch {
    msg = "Unexpected error occurred";
  }

  const show = (text) => toast.error(text, { id: "error" });

  switch (status) {
    case 401:
      // Logout and redirect
      Cookies.remove(process.env.REACT_APP_PR_ACCESS_TOKEN, {
        domain: process.env.REACT_APP_COOKIE_DOMAIN,
      });
      Cookies.remove(process.env.REACT_APP_PR_APP_SESSION_COOKIE, {
        domain: process.env.REACT_APP_COOKIE_DOMAIN,
      });

      if (isExtension) {
        window.dispatchEvent(new CustomEvent("user_unauthenticated_ext", { detail: true }));
      } else {
        window.location.href = `/${process.env.REACT_APP_APP_HOME}/login`;
        window.dispatchEvent(new CustomEvent("user_unauthenticated", { detail: true }));
      }
      break;

    case 429:
      show("You have exceeded request limit. Please try again in sometime.");
      break;

    case 404:
      show(msg || "Error 404! We could not find the resource you are accessing.");
      break;

    case 419:
      show(msg || "Session expired! Please try refreshing the page.");
      break;

    case 422:
      if (msg) show(msg);
      break;

    default:
      if (status >= 400 && msg) show(msg);
  }
};
